/**
 * Custom Header Scroll Behavior
 * Header stays visible at all times.
 * Adds .is-scrolled when past the top (for page-specific style overrides).
 */

(function() {
  'use strict';

  const header = document.querySelector('.custom-header');
  const scrollThreshold = 10;
  const scrolledClass = 'is-scrolled';

  if (!header) return;

  function handleScroll() {
    const currentScroll = window.scrollY || document.documentElement.scrollTop;

    if (currentScroll > scrollThreshold) {
      header.classList.add(scrolledClass);
    } else {
      header.classList.remove(scrolledClass);
    }

    // Never hide the header
    header.classList.remove('is-hidden');
  }

  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  handleScroll();
})();
